/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentMethodCard
 */
export interface PaymentMethodCard {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCard
     */
    brand: string;
    /**
     * Last 4 digits of the card number
     * @type {string}
     * @memberof PaymentMethodCard
     */
    last4: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodCard
     */
    expMonth: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethodCard
     */
    expYear: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCard
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCard
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the PaymentMethodCard interface.
 */
// @ts-ignore
export function instanceOfPaymentMethodCard(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "brand" in value;
    isInstance = isInstance && "last4" in value;
    isInstance = isInstance && "expMonth" in value;
    isInstance = isInstance && "expYear" in value;
    isInstance = isInstance && "isDefault" in value;
    isInstance = isInstance && "isActive" in value;

    return isInstance;
}

// @ts-ignore
export function PaymentMethodCardFromJSON(json: any): PaymentMethodCard {
    return PaymentMethodCardFromJSONTyped(json, false);
}

// @ts-ignore
export function PaymentMethodCardFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodCard {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brand': json['brand'],
        'last4': json['last4'],
        'expMonth': json['exp_month'],
        'expYear': json['exp_year'],
        'isDefault': json['is_default'],
        'isActive': json['is_active'],
    };
}

// @ts-ignore
export function PaymentMethodCardToJSON(value?: PaymentMethodCard | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brand': value.brand,
        'last4': value.last4,
        'exp_month': value.expMonth,
        'exp_year': value.expYear,
        'is_default': value.isDefault,
        'is_active': value.isActive,
    };
}

